<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text"
        block
        v-on="on"
      >
        Copy Annual Holiday
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Holiday detail replication"
      text="Copy holiday detail from a past year"
      class="mb-0"
    > 
      <form
        v-if="dialog"
        ref="detailCreateForm"
      >
        <v-container class="pb-0">
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="form.baseYear"
                v-validate="'required'"
                :error-messages="errors.collect('baseYear')"
                data-vv-name="baseYear" 
                data-vv-as="base year"
                :items="availableYears"
                item-text="name"
                return-object
                label="Base Year"
                outlined
              >
                <template v-slot:prepend-inner>
                  <v-icon>
                    mdi-calendar
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="form.destinationYear"
                v-validate="'required'"
                :error-messages="errors.collect('destinationYear')"
                data-vv-name="destinationYear"
                data-vv-as="destination year"  
                :items="validYears"
                item-text="name"
                outlined
                return-object
                label="Destination Year"
              >
                <template v-slot:prepend-inner>
                  <v-icon>
                    mdi-calendar
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-container>       
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"   
          class="white--text px-10"       
          @click="submitForm"
        >
          Copy
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {      
      availableYears: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        form: {
          baseYear: null,
          destinationYear: null,
        },
      }
    },
    computed: {
      validYears () {
        return [
          this.$moment().year(),
          this.$moment().year() + 1,
        ]
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) {
          this.$resetData()
        }
      },
    },
    created () {
    },
    methods: { 
      prepareFormData () {
        return {
          ...this.form,
        }
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 
            this.setProgressing(true)
    
            this.$api.hrisHolidayDetails().createMany(this.prepareFormData())
              .then((res) => {
                if (res.status === 200) {
                  this.$snack({ message: 'Holidays successfully copied' })
                  this.$validator.pause()

                  this.setDialog(false)
                  this.$emit('created', this.form.destinationYear)                
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
    },
  }
</script>

<style lang="css" scoped>
  ::v-deep .datepicker .v-btn{
      padding:0 !important;
      border-radius: 50%;
  }

</style>
